module.exports = __webpack_public_path__ + "static/cf262b73b5027e72d9a045ad32d8d16c656e16f4d9d6062cb63d983bad87b581-77df77f86a3348ecc41bec0308f5cc4a.png";